import angular from 'angular';

export const selector = 'dbACaptureKeys';

/* @ngInject */
export default function CaptureKeysDirective($parse, $document) {
    return {
        restrict: 'A',
        require: 'ngModel',

        link(scope, element, attrs) {
            const enabled = $parse(attrs[selector]);
            const $body = angular.element($document[0].body);

            $body.on('keypress', handleCapture);
            element.on('keydown', handleEscape);
            scope.$on('$destroy', () => {
                $body.off('keypress', handleCapture);
                element.off('keydown', handleEscape);
            });

            function handleCapture(event) {
                if (enabled(scope) && event.which !== 13 && element[0] !== $document[0].activeElement) {
                    element[0].focus();
                }
            }

            function handleEscape(event) {
                switch (event.which) {
                    case 27:
                        element[0].blur();
                        break;
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/capture-keys/capture-keys.directive.js